<template>
    <div id="ManageRef">
        <b-container>
            <b-row align-h="center">
                {{ itemName }}.
                <span class="txtShad ml-1" v-if="whereChoice === 'from'"> {{ $t('WHERE_FROM') }}</span>
                <span class="txtShad ml-1" v-else-if="whereChoice === 'to' && itemType === 'o' || itemType === 's'"> {{ $t('WHERE_TO') }}</span>

            </b-row>
            <br>
            <b-row align-v="center">
                <b-col>
                    <b-form-group>
                        Country Ru
                        <b-form-input
                                v-model.trim="$v.countryRu.$model"
                                :state="validateState('countryRu')"
                                :placeholder=countryRu
                                aria-described-by="input-1Ru"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-1Ru"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selCountryRu"
                            :options="optCountryRu"
                            @change="chCountry('ru')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-group>
                        Country En
                        <b-form-input
                                v-model.trim="$v.countryEn.$model"
                                :state="validateState('countryEn')"
                                aria-described-by="input-1En"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-1En"
                        >{{this.$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selCountryEn"
                            :options="optCountryEn"
                            @change="chCountry('en')"
                    >
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row align-v="center">
                <b-col>
                    <b-form-group>
                        District Ru
                        <b-form-input
                                v-model.trim="$v.districtRu.$model"
                                :state="validateState('districtRu')"
                                aria-described-by="input-2Ru"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-2Ru"
                        >{{this.$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selDistrictRu"
                            :options="optDistrictRu"
                            @change="chDistrict('ru')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-group>
                        District En
                        <b-form-input
                                v-model.trim="$v.districtEn.$model"
                                :state="validateState('districtEn')"
                                aria-described-by="input-2En"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-2En"
                        >{{this.$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selDistrictEn"
                            :options="optDistrictEn"
                            @change="chDistrict('en')"
                    >
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row align-v="center">
                <b-col>
                    <b-form-group>
                        City Ru
                        <b-form-input
                                v-model.trim="$v.cityRu.$model"
                                :state="validateState('cityRu')"
                                aria-described-by="input-3Ru"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-3Ru"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selCityRu"
                            :options="optCityRu"
                            @change="chCity('ru')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-group>
                        City En
                        <b-form-input
                                v-model.trim="$v.cityEn.$model"
                                :state="validateState('cityEn')"
                                aria-described-by="input-3En"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-3En"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selCityEn"
                            :options="optCityEn"
                            @change="chCity('en')"
                    >
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row align-v="center" v-if="itemType == 'o'">
                <b-col>
                    <b-form-group>
                        Ensemble Ru
                        <b-form-input
                                v-model.trim="$v.ensembleRu.$model"
                                :state="validateState('ensembleRu')"
                                aria-described-by="input-5Ru"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-5Ru"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selEnsembleRu"
                            :options="optEnsembleRu"
                            @change="chEnsemble('ru')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-group>
                        Ensemble En
                        <b-form-input
                                v-model.trim="$v.ensembleEn.$model"
                                :state="validateState('ensembleEn')"
                                aria-described-by="input-5En"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-5En"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selEnsembleEn"
                            :options="optEnsembleEn"
                            @change="chEnsemble('en')"
                    >
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row align-v="center" v-if="itemType == 'o'">
                <b-col>
                    <b-form-group>
                        Sight Ru
                        <b-form-input
                                v-model.trim="$v.sightRu.$model"
                                :state="validateState('sightRu')"
                                aria-described-by="input-4Ru"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-4Ru"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selSightRu"
                            :options="optSightRu"
                            @change="chSight('ru')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-group>
                        Sight En
                        <b-form-input
                                v-model.trim="$v.sightEn.$model"
                                :state="validateState('sightEn')"
                                aria-described-by="input-4En"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-4En"
                        >{{this.$t('R_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-select
                            v-model="selSightEn"
                            :options="optSightEn"
                            @change="chSight('en')"
                    >
                    </b-form-select>
                </b-col>
            </b-row>



            <b-row v-if="resType === 'offers'">
            <b-col>
                <div class="text-center">
                    <b-button class="m-1" @click="whereChoice='to'; itemType='o'; getItemGeoRef()">{{ $t('WHERE_TO') }}</b-button>
                    <b-button class="m-1" @click="whereChoice='from'; itemType='s'; getItemGeoRef()">{{ $t('WHERE_FROM') }}</b-button>
                </div>
            </b-col>
            </b-row>


        </b-container>

        <b-container fluid class="footer text-center">
            <b-form-group>
            <b-button @click.stop.prevent="refAdd()">{{this.$t('ADD')}}</b-button>
            <b-button @click.stop.prevent="$bvModal.show('modal-utl')">{{this.$t('DELETE')}}</b-button>
            <b-button @click.stop.prevent="cancel()">{{this.$t('CANCEL')}}</b-button>
            <b-form-checkbox v-if="itemType=='t'"
                    size="lg"
                    v-model="fixTripPlaces"
                    name="fixTripPlaces"
                    value="checked"
                    unchecked-value="unchecked"
            >
                {{this.$t('PLACES')}}
            </b-form-checkbox>
            </b-form-group>
        </b-container>

        <b-modal id="modal-utl" ref="modal-utl" no-close-on-backdrop>
            <template v-slot:modal-header>
                {{ $t("SURE")}}
                <b-button size="sm" @click="$bvModal.hide('modal-utl')">
                    x
                </b-button>
            </template>
            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('modal-utl')">
                    {{ $t("CANCEL")}}
                </b-button>
                <b-button @click="delYes()">
                    {{ $t("DELETE")}}
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BModal, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BFormCheckbox} from 'bootstrap-vue';
import { validationMixin } from "vuelidate";
import { helpers, minLength, maxLength, requiredIf } from 'vuelidate/lib/validators';

const itemNameRu = helpers.regex('itemNameR',/^(?!\.)(?!.*?[\s]{2})(?!.*?[-]{2})(?!.*?(\s-\S))(?!.*?[']{3})(?!.*?["]{3})[a-zA-Z0-9.,():\-'"а-яА-ЯёЁ\s]+$/);
const itemNameEn = helpers.regex('itemNameR',/^(?!\.)(?!.*?[\s]{2})(?!.*?[-]{2})(?!.*?(\s-\S))(?!.*?[']{3})(?!.*?["]{3})[a-zA-Z0-9.,():\-'"\s]+$/);

export default {
  name: 'MangeRef',
  components: {
    BContainer, BRow, BCol, BButton, BModal, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BFormCheckbox},
  mixins: [validationMixin],
  data: function() {
    return {
        userName: '',
        curUserName: '',
        itemName: '',
        itemType: '',
        resType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        ensembleRu: '',
        ensembleEn: '',
        sightRu: '',
        sightEn: '',
        selCountryRu: '',
        optCountryRu: [{}],
        selCountryEn: '',
        optCountryEn: [{}],
        selDistrictRu: '',
        optDistrictRu: [{}],
        selDistrictEn: '',
        optDistrictEn: [{}],
        selCityRu: '',
        optCityRu: [{}],
        selCityEn: '',
        optCityEn: [{}],
        selEnsembleRu: '',
        optEnsembleRu: [{}],
        selEnsembleEn: '',
        optEnsembleEn: [{}],
        selSightRu: '',
        optSightRu: [{}],
        selSightEn: '',
        optSightEn: [{}],
        sure: null,
        refType: '',
        fixTripPlaces: 'unchecked',
        whereChoice: 'to'
    }
  },
  metaInfo() {
    return {
        title: 'itsmap.ru'
    }
  },
  mounted() {
    if(this.$store.state.curUserName!='admin') this.$showErr(this.$t('TMOUT'), 401);
    this.userName = this.$rmEncHyp(this.$route.query.userName);
    this.curUserName = this.$store.state.curUserName;
    this.itemName = this.$rmEncHyp(this.$route.query.itemName);
    this.itemType = this.$route.query.itemType;
    //console.log(this.userName, this.itemName, this.itemType);
    if(this.itemType === 'c') this.whereChoice = '';
    if(this.itemType === 'o') this.resType = "offers"
    else if (this.itemType === 'c') this.resType = "business"
    else this.resType = "travels"
    this.getCountries();
    this.getItemGeoRef();
  },
  methods: {
    async getItemGeoRef() {
        //let itemType = this.itemType;
        if(this.whereChoice == "from") this.itemType = "s";
        try {
            const response = await this.$http.get('/getItemGeoRef', {
                params: {
                    userName: this.userName,
                    itemName: this.itemName,
                    itemType: this.itemType
                }
            });
            this.countryRu = this.$v.countryRu.$model = response.data.countryRu;
            this.countryEn = this.$v.countryEn.$model = response.data.countryEn;
            if(this.countryEn) this.getDistricts();
            this.districtRu = this.$v.districtRu.$model = response.data.districtRu;
            this.districtEn = this.$v.districtEn.$model = response.data.districtEn;
            if(this.districtEn) {
                this.getCities();
                this.cityRu = this.$v.cityRu.$model = response.data.cityRu;
                this.cityEn = this.$v.cityEn.$model = response.data.cityEn;
                if(this.cityEn) {
                    this.getEnsembles();
                    this.ensembleRu = this.$v.ensembleRu.$model = response.data.ensembleRu;
                    this.ensembleEn = this.$v.ensembleEn.$model = response.data.ensembleEn;
                    this.getSights();
                    this.sightRu = this.$v.sightRu.$model = response.data.sightRu;
                    this.sightEn = this.$v.sightEn.$model = response.data.sightEn;
                }
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getCountries() {
        try {
            const response = await this.$http.get('/getAllCountries', {
                params: {
                    resType: this.resType,
                    itemType: this.itemType
                }
            });
            this.optCountryRu = response.data.optRefsRu;
            this.optCountryEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getDistricts() {
        try {
            const response = await this.$http.get('getAllDistricts', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    resType: this.resType,
                    itemType: this.itemType
                }
            });
            this.optDistrictRu = response.data.optRefsRu;
            this.optDistrictEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getCities() {
        try {
            const response = await this.$http.get('getAllCities', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    resType: this.resType,
                    itemType: this.itemType
                }
            });
            this.optCityRu = response.data.optRefsRu;
            this.optCityEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getEnsembles() {
        try {
            const response = await this.$http.get('getAllEnsembles', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    resType: this.resType,
                    itemType: this.itemType
                }
            });
            this.optEnsembleRu = response.data.optRefsRu;
            this.optEnsembleEn = response.data.optRefsEn;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('MangeRef: getEnsembles() '+error.message);
            else {
                this.statusCode = error.response.status;
                this.$showErr(error.response.data, error.response.status);
            }
        }

    },
    async getSights() {
        try {
            const response = await this.$http.get('getAllSights', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    resType: this.resType,
                    itemType: this.itemType
                }
            });
            this.optSightRu = response.data.optRefsRu;
            this.optSightEn = response.data.optRefsEn;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('MangeRef: getSights() '+error.message);
            else {
                this.statusCode = error.response.status;
                this.$showErr(error.response.data, error.response.status);
            }
        }
    },
    async refAdd() {
        this.$v.$touch();
        if(this.$v.$anyError) return;
        let action = 'refAdd';
        if(this.fixTripPlaces === 'checked') action = 'refTripPlacesAdd';
        //let itemType = this.itemType;
        if(this.whereChoice === 'from') this.itemType = 's';
        try {
            //console.log(this.userName, this.itemName, this.itemType);
            await this.$http.get(action, {
                params: {
                    userName: this.userName,
                    itemName: this.itemName,
                    itemType: this.itemType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn
                }
            });
            this.$showMsg(this.$t('DONE'));
         } catch(error) {
            this.$showErr(error.response.data, error.response.status);
        } finally {
            this.$router.go(-1);
        }
    },
    cancel() {
        this.$router.go(-1);
    },
    async delYes() {
        this.$bvModal.hide('modal-utl');
        //let itemType = this.itemType;
        if(this.whereChoice == "from") this.itemType = "s";
        let action = 'refDel';
        if(this.fixTripPlaces === 'checked') action = 'refTripPlacesDel';
        //console.log(this.districtRu, this.districtEn)
        try {
            await this.$http.get(action, {
                params: {
                    userName: this.userName,
                    itemName: this.itemName,
                    itemType: this.itemType,
                    //refType: this.refType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn
                }
            });
            this.$showMsg(this.$t('DONE'));
        } catch(error) {
            this.$showErr(error.response.data, error.response.status);
        } finally {
            this.$router.go(-1)
        }
    },
    chCountry(code) {
        if(code==='ru') {
                this.countryRu = this.optCountryRu[this.selCountryRu].text;
                this.countryEn = this.optCountryEn[this.selCountryRu].text;
                this.selCountryEn = this.optCountryEn[this.selCountryRu].value;
        } else {
                this.countryEn = this.optCountryEn[this.selCountryEn].text;
                this.countryRu = this.optCountryRu[this.selCountryEn].text;
                this.selCountryRu = this.optCountryRu[this.selCountryEn].value;
        }
        this.clearDistricts();
        this.clearCities();
        this.clearEnsembles();
        this.clearSights();
        this.getDistricts();
    },
    chDistrict(code) {
        if(code==='ru') {
                this.districtRu = this.optDistrictRu[this.selDistrictRu].text;
                this.districtEn = this.optDistrictEn[this.selDistrictRu].text;
                this.selDistrictEn = this.optDistrictEn[this.selDistrictRu].value;
        } else {
                this.districtEn = this.optDistrictEn[this.selDistrictEn].text;
                this.districtRu = this.optDistrictRu[this.selDistrictEn].text;
                this.selCountryRu = this.optDistrictRu[this.selDistrictEn].value;
        }
        this.clearCities();
        this.clearEnsembles();
        this.clearSights();
        this.getCities();
    },
    chCity(code) {
        if(code==='ru') {
                this.cityRu = this.optCityRu[this.selCityRu].text;
                this.cityEn = this.optCityEn[this.selCityRu].text;
                this.selCityEn = this.optCityEn[this.selCityRu].value;
        } else {
                this.cityEn = this.optCityEn[this.selCityEn].text;
                this.cityRu = this.optCityRu[this.selCityEn].text;
                this.selCityRu = this.optCityRu[this.selCityEn].value;
        }
        this.clearEnsembles();
        this.clearSights();
        this.getEnsembles();
        this.getSights();
    },
    chEnsemble(code) {
        if(code==='ru') {
            this.ensembleRu = this.optEnsembleRu[this.selEnsembleRu].text;
            this.ensembleEn = this.optEnsembleEn[this.selEnsembleRu].text;
            this.selEnsembleEn = this.optEnsembleEn[this.selEnsembleRu].value;
        } else {
            this.ensembleEn = this.optEnsembleEn[this.selEnsembleEn].text;
            this.ensembleRu = this.optEnsembleRu[this.selEnsembleEn].text;
            this.selEnsembleRu = this.optEnsembleRu[this.selEnsembleEn].value;
        }
        this.clearSights;
        this.getSights();
    },
    chSight(code) {
        if(code==='ru') {
            this.sightRu = this.optSightRu[this.selSightRu].text;
            this.sightEn = this.optSightEn[this.selSightRu].text;
            this.selSightEn = this.optSightEn[this.selSightRu].value;
        } else {
            this.sightEn = this.optSightEn[this.selSightEn].text;
            this.sightRu = this.optSightRu[this.selSightEn].text;
            this.selSightRu = this.optSightRu[this.selSightEn].value;
        }
    },
    clearDistricts() {
        this.districtRu = '';
        this.districtEn = '';
        this.selDistrictRu = '';
        this.optDistrictRu = [{}];
        this.selDistrictEn = '';
        this.optDistrictEn = [{}];
    },
    clearCities() {
        this.cityRu = '';
        this.cityEn = '';
        this.selCityRu = '';
        this.optCityRu = [{}];
        this.selCityEn = '';
        this.optCityEn = [{}];
    },
    clearEnsembles() {
        this.ensembleRu = '';
        this.ensembleEn = '';
        this.selEnsembleRu = '';
        this.optEnsembleRu = [{}];
        this.selEnsembleEn = '';
        this.optEnsembleEn = [{}];
    },
    clearSights() {
        this.sightRu = '';
        this.sightEn = '';
        this.selSightRu = '';
        this.optSightRu = [{}];
        this.selSightEn = '';
        this.optSightEn = [{}];
    },
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    }
  },
  validations: {
      countryRu: {
          itemNameRu,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.countryEn || this.districtRu) ? false: true;
          })
      },
      countryEn: {
          itemNameEn,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.countryRu || this.districtEn) ? false: true;
          })
      },
      districtRu: {
          itemNameRu,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.districtEn || this.cityRu) ? false: true
          })
     },
      districtEn: {
          itemNameEn,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.districtRu || this.cityEn) ? false: true
          })
      },
      cityRu: {
          itemNameRu,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.cityEn || this.sightRu) ? false: true;
          })
      },
      cityEn: {
          itemNameEn,
          minLength: minLength(1),
          maxLength: maxLength(64),
          required: requiredIf(function () {
            return (!this.cityRu || this.sightEn) ? false: true;
          })
      },
      ensembleRu: {
          itemNameRu,
          minLength: minLength(1),
          maxLength: maxLength(96),
          required: requiredIf(function () {
            return (!this.ensembleEn || this.ensembleRu) ? false: true;
          })
      },
      ensembleEn: {
          itemNameEn,
          minLength: minLength(1),
          maxLength: maxLength(96),
          required: requiredIf(function () {
            return (!this.ensembleRu || this.ensembleEn) ? false: true;
          })
      },
      sightRu: {
          itemNameRu,
          minLength: minLength(1),
          maxLength: maxLength(96),
          required: requiredIf(function () {
            return !this.sightEn ? false: true;
          })
      },
      sightEn: {
          itemNameEn,
          minLength: minLength(1),
          maxLength: maxLength(96),
          required: requiredIf(function () {
            return !this.sightRu ? false: true;
          })
      }
  }

}

</script>

<style>
</style>